export const sources={avif:"__VITE_ASSET__DULehjN9__ 80w"};export const img={src:"__VITE_ASSET__Bc9ZyNdt__",w:80,h:38};export default{sources:sources,img:img};